export default () => ({
  infoVisible: true,
  cookies: {
    ahoy: false,
    youtube: false,
  },
});
